import type { BelegParteien as PartiesState } from "@kundeninfo/api-client";
import { laufzeitVorschauWerte } from "../PositionsEditor.js";
import { SECTION_TEXT } from "./texts.js";

/*
 * Die Zusammenfassungen zugeklappter Vorgangsabschnitte (Spec-Tabelle „Anwendung auf die drei Vorgangsdialoge“, Spalte
 * „Zugeklappt sichtbar“) — EINMAL hier, damit Angebot und Auftrag dieselben Sätze bilden. `undefined` heißt: noch nichts
 * zu sagen (Stand nicht geladen), der Kopf bleibt dann ohne Zusammenfassung.
 */

/** Die Laufzeitfelder eines Entwurfs (Rohtexte), wie sie die Platzhaltervorschau liest. */
export type TermFields = Parameters<typeof laufzeitVorschauWerte>[0];

/** „24 Monate · Kündigung 3 Monate“ — aus denselben Wortformen wie die Platzhaltervorschau, sonst „leer“. */
export function termSummary(fields: TermFields): string {
  const w = laufzeitVorschauWerte(fields);
  const notice = w["laufzeit.kuendigungsfrist.wert"] === undefined ? null
    : `${w["laufzeit.kuendigungsfrist.wert"]} ${w["laufzeit.kuendigungsfrist.einheit"] ?? ""}`;
  return SECTION_TEXT.termSummary(w["laufzeit.vertragslaufzeit"] ?? null, notice);
}

/**
 * Parteien: der abweichende Käufer, sonst der Kunde. `draftBuyerId` ist der Käufer des Entwurfs (`undefined` = unberührt,
 * `null` = kein abweichender Käufer); ein noch ungespeicherter Wechsel nennt den Kandidaten.
 */
export function partiesSummary(
  loaded: PartiesState | null, draftBuyerId: string | null | undefined, customerName: string | undefined,
): string | undefined {
  if (loaded === null) return undefined;
  const buyer = draftBuyerId === undefined ? loaded.billingCustomerId : draftBuyerId;
  if (buyer === null) return customerName;
  return buyer === loaded.billingCustomerId ? loaded.billingCustomerName ?? undefined
    : loaded.kaeuferKandidaten.find((k) => k.id === buyer)?.companyName;
}

/** Zahlungsvereinbarung: „n Raten“, ohne Raten „leer“. */
export function ratesSummary(count: number | null | undefined): string | undefined {
  return count === null || count === undefined ? undefined : SECTION_TEXT.rates(count);
}
